export default [
    //费率表
    {
        num: "0-100万", //计费额
        goods: "1.5%", //货物
        service: "1.5%", //服务
        engineering: "1.0%", //工程
    },
    {
        num: "100万-500万", //计费额
        goods: "0.011%", //货物
        service: "0.008%", //服务
        engineering: "0.007%", //工程
    },
    {
        num: "500万-1000万", //计费额
        goods: "0.80%", //货物
        service: "0.45%", //服务
        engineering: "0.55%", //工程
    },
    {
        num: "1000万-5000万", //计费额
        goods: "0.50%", //货物
        service: "0.25%", //服务
        engineering: "0.35%", //工程
    },
    {
        num: "5000万-1亿", //计费额
        goods: "0.25%", //货物
        service: "0.10%", //服务
        engineering: "0.20%", //工程
    },
    {
        num: "1亿-5亿", //计费额
        goods: "0.05%", //货物
        service: "0.05%", //服务
        engineering: "0.05%", //工程
    },
    {
        num: "5亿-10亿", //计费额
        goods: "0.035%", //货物
        service: "0.035%", //服务
        engineering: "0.035%", //工程
    },
    {
        num: "10亿-50亿", //计费额
        goods: "0.008%", //货物
        service: "0.008%", //服务
        engineering: "0.008%", //工程
    },
    {
        num: "50亿-100亿万", //计费额
        goods: "0.006%", //货物
        service: "0.006%", //服务
        engineering: "0.006%", //工程
    },
    {
        num: "100亿以上", //计费额
        goods: "0.004%", //货物
        service: "0.004%", //服务
        engineering: "0.004%", //工程
    },
]